import type { ProgramId, TermId } from "./fees";
import { GRADE_OPTIONS } from "./fees";

/** Kalenderåret för höstterminen i det läsår som terminen tillhör. */
export function schoolYearStart(term: TermId): number {
  const year = 2000 + Number(term.slice(2));
  if (!Number.isFinite(year)) return new Date().getFullYear();
  // Vårterminen tillhör läsåret som startade föregående höst.
  return term.startsWith("VT") ? year - 1 : year;
}


export type Placement = {
  grade: string | null;
  program: ProgramId | null;
  label: string;
  ageInAutumn: number | null;
};

/**
 * Svensk modell: barnet fyller 6 år kalenderåret det börjar förskoleklass,
 * 7 år kalenderåret det börjar årskurs 1 och så vidare.
 */
export function suggestPlacement(birthDateIso: string, term: TermId): Placement {
  const birthYear = Number(birthDateIso.slice(0, 4));
  if (!birthYear) {
    return { grade: null, program: null, label: "Fyll i födelsedatum för förslag", ageInAutumn: null };
  }
  const age = schoolYearStart(term) - birthYear;

  let grade: string | null = null;
  if (age >= 3 && age <= 5) grade = "forskola";
  else if (age === 6) grade = "forskoleklass";
  else if (age >= 7 && age <= 15) grade = `ak${age - 6}`;
  else if (age >= 16 && age <= 18) grade = `gy${age - 15}`;

  if (!grade) {
    return {
      grade: null,
      program: null,
      label:
        age < 3
          ? "Barnet är yngre än 3 år vid terminsstart – kontakta skolan."
          : "Åldern ligger utanför skolans nivåer – kontakta skolan.",
      ageInAutumn: age,
    };
  }

  const option = GRADE_OPTIONS.find((g) => g.value === grade)!;
  return { grade, program: option.program, label: option.label, ageInAutumn: age };
}
